/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useProductDetails } from '@/data/Content/ProductDetails';
// import { useLocalization } from '@/data/Localization';
import { ContentContext } from '@/data/context/content';
import { ProductAvailabilityData } from '@/data/types/ProductAvailabilityData';
import TimerIcon from '@mui/icons-material/Timer';
// import { parseHTML } from '@/utils/parseHTML';
import {
	Stack,
	// Stack,
	Typography,
	Fade,
} from '@mui/material';
import { FC, useContext } from 'react';
import { ProductToExhaustTextSx } from '@/components/blocks/ProductDetails/styles/availability';

const EMPTY_AVAILABILITY: ProductAvailabilityData[] = [];

export const ProductDetailsAvailability: FC = () => {
	// const localization = useLocalization('CommerceEnvironment');
	// const prodLoc = useLocalization('productDetail');
	const { availability = EMPTY_AVAILABILITY } = useContext(ContentContext) as ReturnType<
		typeof useProductDetails
	>;

	const availableQuantity = availability.length ? Number(availability[0].availableQuantity) : 0;


	if (availableQuantity > 15 || availableQuantity === 0) {
		return <Stack sx={{ height: '0px' }}></Stack>;
	}

	return (
		<Fade in={true} timeout={1000}>
			<Typography sx={ProductToExhaustTextSx}>
				<TimerIcon
					sx={{
						color: 'inherit',
						fontSize: 'var(--font-size-default)',
						marginRight: 0.5,
						my: '6px',
					}}
				/>
				{'Quedan pocas piezas, haz tu pedido pronto.'}
			</Typography>
		</Fade>
	);

	// return (
	// 	<Stack spacing={0.5}>
	// 		<Typography variant="body2">{prodLoc.Availability.t()}</Typography>
	// 		{availability.length === 0 ? (
	// 			<Typography data-testid="not-available" id="not-available">
	// 				{localization.inventoryStatus.NA.t()}
	// 			</Typography>
	// 		) : (
	// 			availability.map(
	// 				({ physicalStoreId, status, physicalStoreStatus, partNumber, storeName: store }) => (
	// 					<Typography
	// 						key={`${partNumber} in ${store}`}
	// 						data-testid={`${partNumber} in ${store}`}
	// 						id={`${partNumber} in ${store}`}
	// 					>
	// 						{parseHTML(
	// 							physicalStoreId
	// 								? physicalStoreStatus
	// 									? localization.inventoryStatusStore.Available.t({ store })
	// 									: localization.inventoryStatusStore.OOS.t({ store })
	// 								: status
	// 								? localization.inventoryStatusOnline.Available.t()
	// 								: localization.inventoryStatusOnline.OOS.t()
	// 						)}
	// 					</Typography>
	// 				)
	// 			)
	// 		)}
	// 	</Stack>
	// );
};
